import { render, staticRenderFns } from "./EditQuestionnaireBody.vue?vue&type=template&id=3cf54dea"
import script from "./EditQuestionnaireBody.vue?vue&type=script&lang=js"
export * from "./EditQuestionnaireBody.vue?vue&type=script&lang=js"
import style0 from "./EditQuestionnaireBody.vue?vue&type=style&index=0&id=3cf54dea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports